import { render, staticRenderFns } from "./FederatedDataSpace.vue?vue&type=template&id=d39021f8&"
import script from "./FederatedDataSpace.vue?vue&type=script&lang=ts&"
export * from "./FederatedDataSpace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports